/*
 * Orbe country-gated visibility.
 *
 * Elements marked `data-orbe-country="US"` (comma-separated ISO codes) are shown
 * by default and HIDDEN only when the country SELECTED in the Orbe country
 * selector is not in the allowed list. Rendering visible by default means a US
 * (or not-yet-resolved) visitor always sees the content — it never gets hidden
 * from US customers while Orbe is still initialising.
 *
 * The selected country is read from the Orbe country selector: Orbe keeps it on
 * `window.mdApp_currentCountryCode`; as a fallback we read the selector element
 * itself (Shopify localization `country_code` field / Orbe selector).
 */
(function () {
  function selectedCountry() {
    // 1) Orbe's current country (set by the Orbe country selector).
    var c = window.mdApp_currentCountryCode;
    if (typeof c === 'string' && c.length === 2) return c.toUpperCase();

    // 2) Fallback: read the Orbe / Shopify localization country selector element.
    var el = document.querySelector(
      '.md-orbe-selector__container select[name="country_code"],' +
        '.md-orbe-selector__container select,' +
        'form[action*="localization"] select[name="country_code"],' +
        'select[name="country_code"]'
    );
    if (el && el.value && el.value.length >= 2) {
      return el.value.slice(0, 2).toUpperCase();
    }
    return null;
  }

  function apply() {
    var country = selectedCountry();
    if (!country) return false; // country unknown yet — leave elements visible

    var els = document.querySelectorAll('[data-orbe-country]');
    for (var i = 0; i < els.length; i++) {
      var allowed = els[i]
        .getAttribute('data-orbe-country')
        .split(',')
        .map(function (s) {
          return s.trim().toUpperCase();
        });
      if (allowed.indexOf(country) === -1) {
        // Selected country is not allowed → hide.
        els[i].hidden = true;
      } else {
        // Allowed → make sure it is visible.
        els[i].hidden = false;
        els[i].removeAttribute('hidden');
      }
    }
    return true;
  }

  // Orbe's script loads asynchronously — poll briefly until the selected country
  // is available, then stop.
  var tries = 0;
  (function poll() {
    if (apply() || tries++ > 40) return;
    setTimeout(poll, 150);
  })();

  // Re-evaluate when returning via the back/forward (bfcache) cache.
  window.addEventListener('pageshow', apply);
})();
